var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    !_vm.loaded
      ? _c("div", { staticClass: "loader" }, [
          _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", { staticClass: "blogWrapper blogPage" }, [
          _c("div", { staticClass: "postFilter" }, [
            _c("div", { staticClass: "filterIntro" }, [
              _c("h3", [_vm._v(_vm._s(_vm.header_title))]),
              _vm._v(" "),
              _vm.header_description != ""
                ? _c("div", {
                    staticClass: "filterDescription",
                    domProps: { innerHTML: _vm._s(_vm.header_description) }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "inputFlex" }, [
              _vm.post_filter.filter && _vm.categories_array
                ? _c(
                    "div",
                    { staticClass: "inputWrap" },
                    [
                      _c("label", [_vm._v("By Category")]),
                      _vm._v(" "),
                      _c("v-select", {
                        key: "categories",
                        attrs: {
                          options: _vm.categories_array,
                          id: "categories",
                          placeholder: "All Categories",
                          searchable: false,
                          reduce: function(category) {
                            return category.term_id
                          },
                          label: "cat_name"
                        },
                        model: {
                          value: _vm.category,
                          callback: function($$v) {
                            _vm.category = $$v
                          },
                          expression: "category"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.post_filter.filter.months
                ? _c(
                    "div",
                    { staticClass: "inputWrap" },
                    [
                      _c("label", [_vm._v("Dates")]),
                      _vm._v(" "),
                      _c("v-select", {
                        key: "months",
                        attrs: {
                          options: _vm.post_filter.filter.months,
                          id: "months",
                          placeholder: "Dates"
                        },
                        model: {
                          value: _vm.months,
                          callback: function($$v) {
                            _vm.months = $$v
                          },
                          expression: "months"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "blogPostsWrap",
              class: _vm.reloading ? "reloading" : ""
            },
            [
              _vm.post_filter.posts.length > 0
                ? _c(
                    "div",
                    [
                      _c("posts", { attrs: { posts: _vm.post_filter.posts } }),
                      _vm._v(" "),
                      _vm.post_filter.pagination.total_pages > 1
                        ? _c("paginate", {
                            attrs: {
                              "page-count":
                                _vm.post_filter.pagination.total_pages,
                              "page-range": 7,
                              "margin-pages": 1,
                              "click-handler": _vm.switchPage,
                              "prev-text": "<i class='far fa-angle-left'></i>",
                              "next-text": "<i class='far fa-angle-right'></i>",
                              "container-class": "pagination",
                              "page-class": "page-numbers",
                              "hide-prev-next": true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _c("div", { staticClass: "emptyState" }, [_vm._m(0)])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "emptyStateMessage alert" }, [
        _vm._v(
          "\n                        No results found.\n                    "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }